// Types
import { Components } from '../types';
import styled, {css} from 'styled-components';
import { Helpers } from '../utils';

// Components
import AttributeSelect from './Select';
import Icon from './Icon';
 
const ProductAttributeSelect = ({label, showButton, options, ...selectProps}: any) => {

    return ( 
        <ProductAttributeSelectWrapper>
            <AttributeLabel>
                <span>{label}</span>
                {showButton &&
                    <AttributeButton href="#velikostni-tabulka" onClick={() => {
                        const sizeGuideButton = document?.querySelector('.oxy-tab[data-tab-id=velikostni-tabulka]');
                        const sizeGuideWrapper = document?.querySelector('.wooptima-size-guides__wrapper');
                        sizeGuideButton?.dispatchEvent(new MouseEvent('click', {
                            view: window,
                            bubbles: true,
                            cancelable: true
                        }));
                        setTimeout(() => {
                            sizeGuideWrapper?.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
                        }, 50);
                    }}>
                        <Icon id={`hamburger`} size={0.8} />
                        <span>Tabuľka velikostí</span>
                    </AttributeButton>
                }
            </AttributeLabel>    
            <AttributeSelect options={options} {...selectProps} />     
        </ProductAttributeSelectWrapper>
    )
    
}

const AttributeButton = styled.a(
({ theme: { general, components: {productAttributes: style} } }) => css`
    text-decoration: none;
    margin-left: 1em;
    display: flex;
    cursor: pointer;
    align-items: center;
    color: #757575;
    ${Helpers.clamp('font-size', 0.8, 0.9, 2.5)} 
    transition: color ${general.transition.duration} ${general.transition.timingFunction};
    &:hover {
        color: #1d1d1b;
    }
    svg {
        margin-right: 0.25em;
    }
`)

const AttributeLabel = styled.div(
({ theme: { general, components: {productAttributes: style} } }) => css`
    display: flex;
    align-items: center;
    color: #333;
    margin-bottom: .5em;
    ${Helpers.clamp('font-size', 0.85, 1, 2.5)} 
    font-weight: 500;
    //text-transform: uppercase;

`);

const ProductAttributeSelectWrapper = styled.div(
({ theme: { general, components: {productAttributes: style} } }) => css`

`);

export default ProductAttributeSelect;